import { render, staticRenderFns } from "./DonatePayPayment.vue?vue&type=template&id=5b30b0da&scoped=true&"
import script from "./DonatePayPayment.vue?vue&type=script&lang=js&"
export * from "./DonatePayPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30b0da",
  null
  
)

export default component.exports